import { render, staticRenderFns } from "./fee-fixo-ia-especialista.vue?vue&type=template&id=0e1fd3d3&scoped=true&"
import script from "./fee-fixo-ia-especialista.vue?vue&type=script&lang=js&"
export * from "./fee-fixo-ia-especialista.vue?vue&type=script&lang=js&"
import style0 from "./fee-fixo-ia-especialista.vue?vue&type=style&index=0&id=0e1fd3d3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1fd3d3",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFadeTransition})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e1fd3d3')) {
      api.createRecord('0e1fd3d3', component.options)
    } else {
      api.reload('0e1fd3d3', component.options)
    }
    module.hot.accept("./fee-fixo-ia-especialista.vue?vue&type=template&id=0e1fd3d3&scoped=true&", function () {
      api.rerender('0e1fd3d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fee-fixo/components/fee-fixo-ia-especialista/fee-fixo-ia-especialista.vue"
export default component.exports